<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.15008 6.97727H1.60008C1.08341 6.97727 0.666748 6.49481 0.666748 5.89657V1.74745C0.666748 1.1492 1.08341 0.666748 1.60008 0.666748H6.15008C6.66675 0.666748 7.08341 1.1492 7.08341 1.74745V5.89657C7.08341 6.49481 6.66675 6.97727 6.15008 6.97727ZM2.00008 5.43341H5.75008V2.21061H2.00008V5.43341ZM14.4001 6.97727H9.85008C9.33341 6.97727 8.91675 6.49481 8.91675 5.89657V1.74745C8.91675 1.1492 9.33341 0.666748 9.85008 0.666748H14.4001C14.9167 0.666748 15.3334 1.1492 15.3334 1.74745V5.89657C15.3334 6.49481 14.9167 6.97727 14.4001 6.97727ZM10.2501 5.43341H14.0001V2.21061H10.2501V5.43341ZM6.15008 15.3334H1.60008C1.08341 15.3334 0.666748 14.851 0.666748 14.2527V10.1036C0.666748 9.50535 1.08341 9.0229 1.60008 9.0229H6.15008C6.66675 9.0229 7.08341 9.50535 7.08341 10.1036V14.2527C7.08341 14.851 6.66675 15.3334 6.15008 15.3334ZM2.00008 13.7896H5.75008V10.5668H2.00008V13.7896ZM14.4001 15.3334H9.85008C9.33341 15.3334 8.91675 14.851 8.91675 14.2527V10.1036C8.91675 9.50535 9.33341 9.0229 9.85008 9.0229H14.4001C14.9167 9.0229 15.3334 9.50535 15.3334 10.1036V14.2527C15.3334 14.851 14.9167 15.3334 14.4001 15.3334ZM10.2501 13.7896H14.0001V10.5668H10.2501V13.7896Z" :fill="fill"/>
  </svg>

</template>

<script>
  export default {
    name: 'dashIcon',
    props: {
      fill: {
        type: String,
        default: '#29ABE2'
      }
    }
  }
</script>
